module.exports = __webpack_public_path__ + "img/board-67.0655a1e9.png";